import { adsManagerUrl, type ChangeView } from "@nabla/api";
import { entrypoint, viewOf, type PlaceFacts } from "../../client/index.ts";
import { designCopy } from "../../design/copy.ts";

const mudanca = viewOf("mudanca");

export function changeRequest(p: string) {
  return mudanca({ p });
}

function place(data: ChangeView): PlaceFacts {
  const { summary } = data;
  const name = designCopy.lugares.mudanca(summary.target.name);
  return {
    title: name,
    self: { place: "mudanca", id: summary.id, name, href: `/mudanca/${summary.id}` },
    path: data.path,
    siblings: data.siblings,
    parent: summary.target.href,
    managerUrl: adsManagerUrl({ place: summary.target.place, account: summary.account.id, id: summary.target.id }),
  };
}

export const entrypoints = [entrypoint({
  id: "mudanca",
  path: "/mudanca/:p",
  level: "mudanca",
  data: ({ p }) => changeRequest(p),
  view: () => import("./view.tsx"),
  place,
  morph: ({ p }) => `obj-${p}`,
  missing: () => designCopy.lugares.semMudanca,
})];
